// extracted by mini-css-extract-plugin
export default {"root":"eeATs","title":"TWO3C","benefits":"t2tOs","benefit":"hA_rK","coins":"uxSaR","equal":"Mo1WC","textShader":"WJHRz","avatar":"Jzc2C","button":"ofb5B"};